/* eslint-disable prettier/prettier */
import aIBrain from '../img/RHLSbanner_AI.png';
import aITablet from '../img/RHLSbanner_AITablet.png';
import certification from '../img/RHLSbanner_Certification.png';
import cloudOpenStack from '../img/RHLSbanner_CloudOpenStack.png';
import controlBar from '../img/RHLSbanner_ControlBar.png';
import devOps from '../img/RHLSbanner_DevOps.png';
import digitalBadge from '../img/RHLSbanner_DigitalBadge.png';
import fasterDeployment from '../img/RHLSbanner_FasterDeployment.png';
import kubernetesGraphic from '../img/RHLSbanner_Kubernetes.png';
import ITOptimization from '../img/RHLSbanner_ITOptimization.png';
import bannerRemoteExams from '../img/RHLSbanner_RemoteExams.png';
import personHybridCloud from '../img/RHLSbanner_hybridCloud.png';
import tourDemo from '../img/RHLSbanner_Tour.png';
import techOverviews from '../img/RHLSbanner_TechOverviews.png';
import virtualization from '../img/RHLSbanner_VIRT.png';
import womanLaptop from '../img/RHLSbanner_WomanLaptop.png';
import womanComputer from '../img/RHLSbanner_PersonAtComputer.png';

// DO NOT import animation json files unless they are really being used.
// By importing them the app bundle size is increased significantly and the loading times will also increase
// import earlyAccess from '../img/ea-animation.json';
// import skillsPath from '../img/skills-paths-edited.json';
// import eigthtTopTips from '../img/eightExamTips.json';
// import premium from '../img/premium_hero_animation.json';

import { APP_BASE } from '../config/constants';

export enum ActionType {
  OpenLink = 'openLink',
  ShowVideo = 'showVideo',
}

const imgs = {
  aIBrain,
  aITablet,
  certification,
  cloudOpenStack,
  controlBar,
  devOps,
  digitalBadge,
  fasterDeployment,
  kubernetesGraphic,
  ITOptimization,
  bannerRemoteExams,
  personHybridCloud,
  techOverviews,
  tourDemo,
  virtualization,
  womanLaptop,
  womanComputer,
};

export default [
  {
    title: `New Red Hat OpenShift course`,
    titleColor: `red`,
    description: `Design and implement flexible OpenShift network topologies, with an emphasis on user-defined networks (UDNs) with the new course: Configuring and Managing Red Hat OpenShift Networking (DO282).`,
    descriptionColor: `black`,
    imageUrl: imgs.fasterDeployment,
    imageAlt: 'OpenShift Deployment illlustration',
    actionType: ActionType.OpenLink,
    actionText: 'View',
    actionUrl: `${APP_BASE}/courses/do282-4.20/pages/overview`,
    openActionInNewTab: false,
  },
  {
    title: `New Red Hat OpenShift course`,
    titleColor: `black`,
    description: `Red Hat OpenShift Administration I: Operating a Production Cluster (DO180) is now available on version 4.22 of Red Hat OpenShift.`,
    descriptionColor: `black`,
    imageUrl: imgs.kubernetesGraphic,
    imageAlt: 'OpenShift illlustration',
    actionType: ActionType.OpenLink,
    actionText: 'View',
    actionUrl: `${APP_BASE}/courses/do180-4.22/pages/overview`,
    openActionInNewTab: false,
  },
  {
    title: `Explore the new Red Hat Certification program`,
    titleColor: `red`,
    description: `View the different levels of certification for each pathway to determine where to begin.`,
    descriptionColor: `black`,
    imageUrl: imgs.certification,
    imageAlt: 'Red Hat Training and Certification iconography',
    actionType: ActionType.OpenLink,
    actionText: 'Learn more',
    actionUrl: 'https://www.redhat.com/en/services/certifications',
    openActionInNewTab: true,
  },
  {
    title: `Chat feature connects you to Certified experts`,
    titleColor: `black`,
    description: `Certified experts are available to help you with your self-paced course. Don't let a challenging topic slow you down. Get the expert assistance you need to keep you on your training plan and reach your learning goals.`,
    descriptionColor: `black`,
    imageUrl: imgs.womanComputer,
    imageAlt: 'Person engaging with training on the computer',
    actionType: ActionType.OpenLink,
    actionText: 'Launch chat',
    actionUrl: `${APP_BASE}`,
    openActionInNewTab: false,
    displayForSubscriptions: ['ls000'],
  },
  {
    title: `Welcome to Red Hat Learning Subscription Standard`,
    titleColor: `red`,
    description: `Red Hat Learning Subscription is designed to effectively keep you up to speed with evolving Red Hat technologies.`,
    descriptionColor: `black`,
    imageUrl: imgs.tourDemo,
    imageAlt: 'Red Hat Learning Subscription 4.0 slide',
    actionType: ActionType.ShowVideo,
    actionText: 'View The Tour',
    actionUrl:
      'https://cdnapisec.kaltura.com/p/2032581/embedPlaykitJs/uiconf_id/52299142?iframeembed=true&entry_id=1_41isrruz',
    displayForSubscriptions: ['ls220'],
  },
  {
    title: `Welcome to Red Hat Learning Subscription Basic`,
    titleColor: `red`,
    description: `Red Hat Learning Subscription is designed to effectively keep you up to speed with evolving Red Hat technologies.`,
    descriptionColor: `black`,
    imageUrl: imgs.tourDemo,
    imageAlt: 'Red Hat Branded cloud illustration',
    actionType: ActionType.ShowVideo,
    actionText: 'View The Tour',
    actionUrl:
      'https://cdnapisec.kaltura.com/p/2032581/embedPlaykitJs/uiconf_id/52299142?iframeembed=true&entry_id=1_h07quaro',
    displayForSubscriptions: ['ls120', 'ls130c', 'ls810'],
  },
  {
    title: `Welcome to Red Hat Learning Subscription Developer`,
    titleColor: `red`,
    description: `Red Hat Learning Subscription is designed to effectively keep you up to speed with evolving Red Hat technologies.`,
    descriptionColor: `black`,
    imageUrl: imgs.tourDemo,
    imageAlt: 'Red Hat Branded cloud illustration',
    actionType: ActionType.ShowVideo,
    actionText: 'View The Tour',
    actionUrl:
      'https://cdnapisec.kaltura.com/p/2032581/embedPlaykitJs/uiconf_id/52299142?iframeembed=true&entry_id=1_h2hmxml5',
    displayForSubscriptions: ['ls300'],
  },
  {
    title: `Welcome to Red Hat Learning Subscription Premium`,
    titleColor: `red`,
    description: `Red Hat Learning Subscription is designed to effectively keep you up to speed with evolving Red Hat technologies.`,
    descriptionColor: `black`,
    imageUrl: imgs.tourDemo,
    imageAlt: 'Red Hat Branded cloud illustration',
    actionType: ActionType.ShowVideo,
    actionText: 'View The Tour',
    actionUrl:
      'https://cdnapisec.kaltura.com/p/2032581/embedPlaykitJs/uiconf_id/52299142?iframeembed=true&entry_id=1_7nb59zuy',
    displayForSubscriptions: ['ls520', 'ls105', 'ls000', 'ls101', 'ls999'],
  },
  {
    title: `Welcome to Red Hat Learning Subscription Trial`,
    titleColor: `red`,
    description: `Red Hat Learning Subscription is designed to effectively keep you up to speed with evolving Red Hat technologies.`,
    descriptionColor: `black`,
    imageUrl: imgs.tourDemo,
    imageAlt: 'Red Hat Branded cloud illustration',
    actionType: ActionType.ShowVideo,
    actionText: 'View The Tour',
    actionUrl:
      'https://cdnapisec.kaltura.com/p/2032581/embedPlaykitJs/uiconf_id/52134902?iframeembed=true&entry_id=1_68o4dmiz',
    displayForSubscriptions: ['ls020'],
  },
];
